import EvaluationRouter from '@/components/pages/evaluation/index.vue';
import Evaluations from '@/components/pages/evaluation/Evaluations.vue';
import EvaluationImport from '@/components/pages/evaluation/EvaluationImport.vue';
import EvaluationDetail from '@/components/pages/evaluation/EvaluationDetail.vue';
import ExportGradeEvaluation from '@/components/pages/evaluation/ExportGradeEvaluation.vue'

export default {
  path: '/evaluations',
  name: 'EvaluationRouter',
  component: EvaluationRouter,
  children: [
    {
      path: '/evaluations',
      component: Evaluations,
      name: 'Evaluations',
      meta: {
        acceptRoles: ['senior', 'admin'],
      },
    },
    {
      path: '/evaluations/import',
      component: EvaluationImport,
      name: 'EvaluationImport',
      meta: {
        acceptRoles: ['senior', 'admin'],
      },
    },
    {
      path: '/tutors/:tutorId/evaluations/:evaluationId',
      component: EvaluationDetail,
      name: 'EvaluationDetail',
      meta: {
        acceptRoles: ['senior', 'tutor', 'admin'],
      },
    },
    {
      path: '/evaluations/exportGrade',
      component: ExportGradeEvaluation,
      name: 'ExportGradeEvaluation',
      meta: {
        acceptRoles: ['admin'],
      },
    },
  ],
}
